var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.116,
    height: 17.907,
    viewBox: "14.742 14 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Icon feather-share-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.558 17.233a2.686 2.686 0 1 1-5.372 0 2.686 2.686 0 0 1 5.372 0Z",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    stroke: "#617ba0",
    fill: "transparent",
    "data-name": "Path 63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.814 23.5a2.686 2.686 0 1 1-5.372 0 2.686 2.686 0 0 1 5.372 0Z",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    stroke: "#617ba0",
    fill: "transparent",
    "data-name": "Path 64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.558 29.767a2.686 2.686 0 1 1-5.372 0 2.686 2.686 0 0 1 5.372 0Z",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    stroke: "#617ba0",
    fill: "transparent",
    "data-name": "Path 65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.447 24.852 6.115 3.563",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    stroke: "#617ba0",
    fill: "transparent",
    "data-name": "Path 66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.553 18.585-6.106 3.563",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    stroke: "#617ba0",
    fill: "transparent",
    "data-name": "Path 67"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.a62c7015b682767a5e65e425abd06b50.svg";
export { ForwardRef as ReactComponent };